import type { ReactNode } from 'react'

import { LogOut } from 'lucide-react'

import { type Session } from '../../lib/api'
import ImpersonationBanner from './ImpersonationBanner'
import Sidebar from './Sidebar'
import { stopImpersonating } from './stopImpersonating'
import './shell.css'

export default function AppShell({
  session, children,
}: { session: Session | null; children: ReactNode }) {
  const impersonating = session?.impersonating ?? null
  return (
    <div className={`app-shell${impersonating && (session?.user?.is_platform_admin || session?.user?.is_staff) ? ' is-impersonating' : ''}`}>
      {impersonating && (
        <ImpersonationBanner
          target={impersonating}
          actor={session?.actor ?? null}
          isTargetStaff={session?.user?.is_platform_admin || session?.user?.is_staff || false}
          onStop={() => void stopImpersonating()}
        />
      )}
      {/* The exit on pages that hide the whole sidebar (the match page's
          viewer mode, the bare match video): with a club-user target the
          banner is hidden too, and without this the only way back was to
          sign out (Ben, 2026-10-14). Shown by CSS only there. */}
      {impersonating && (
        <button type="button" className="imp-exit" onClick={() => void stopImpersonating()}
                title={`Viewing as ${impersonating.email}`}>
          <LogOut size={14} aria-hidden /> Return to my account
        </button>
      )}
      <Sidebar session={session} />
      <main className="app-main">{children}</main>
    </div>
  )
}
